import { AxiosError } from 'axios';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_DROPDOWN_REQUEST_TYPES_URL } from '../../constants/apiUrls';
import { GET_DROPDOWN_REQUEST_TYPES_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface DropdownRequestTypeResponse {
  [key: string]: DropdownRequestType[];
}

export interface DropdownRequestType {
  accessArrangementType: string;
  uuidOfType: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: DropdownRequestTypeResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDropdownRequestTypes = ({ onSuccess, onError }: Input = {}) => {
  const getDropdownRequestTypes = async () => {
    const res = await axiosClient.get<DropdownRequestTypeResponse>(GET_DROPDOWN_REQUEST_TYPES_URL);
    return res.data;
  };

  return useCustomQuery(GET_DROPDOWN_REQUEST_TYPES_QUERY_KEY, getDropdownRequestTypes, {
    onSuccess,
    onError,
  });
};
